import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
		wha: null,
		insert: false,
		update: false,
		loading: false
	},
	getters: {
		getWha: state => state.wha,
	},
	mutations: {
		set(state, wha){
			state.wha = wha
			if (wha)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
		}
	},
	actions: {
		async find(store){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get("/OryxPdv/OryxWhatsAppParameters/Find")
			.then(response => {
				let wha = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", wha)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		save(store){
			let wha = store.getters.getWha
			if (wha.whabdsenha === "*********") {
				wha.whabdsenha = ""
			}
			if (wha.whabdusuar === "*********") {
				wha.whabdusuar = ""
			}
			
			
			let payload = null;
			if (store.state.wha.whacodigo){
				payload = store.dispatch("update", wha)
				return payload
			}
			payload = store.dispatch("insert", wha)
			return payload
		},
		async insert(store, wha){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			const payload = await this._vm.$axios.post("/OryxPdv/OryxWhatsAppParameters/Insert", wha )
			.then(async response => {
				Utils.ValidateAxiosResponse(response.data);
				await store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async update(store, wha){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			const payload = await this._vm.$axios.put("/OryxPdv/OryxWhatsAppParameters/Update", wha )
			.then(async response => {
				Utils.ValidateAxiosResponse(response.data);
				await store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete("/OryxPdv/OryxWhatsAppParameters/Delete")
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
	}
}